// Mobile nav slide-out, matching the Tilda export's burger/overlay pattern.
export function initNavToggle() {
	const header = document.getElementById('site-header');
	if (!header) return;

	const toggle = header.querySelector('.site-header__burger');
	const nav = header.querySelector('.site-nav');
	if (!toggle || !nav) return;

	toggle.addEventListener('click', () => {
		const isOpen = header.classList.toggle('is-nav-open');
		toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
		document.body.classList.toggle('no-scroll', isOpen);
	});

	nav.querySelectorAll('a').forEach((link) => {
		link.addEventListener('click', () => {
			header.classList.remove('is-nav-open');
			toggle.setAttribute('aria-expanded', 'false');
			document.body.classList.remove('no-scroll');
		});
	});
}
